export default __webpack_public_path__ + "static/media/5S.9f486769.png";